'use client';

import { CoursesFilterContent } from './filter/courses-filter-content';

export const CoursesFilterLeft = () => {
  return (
    <div className="flex flex-col gap-6 rounded-lg bg-[#F3F3F3] p-6">
      <CoursesFilterContent />
    </div>
  );
};
